import React from 'react';
import { useT } from '../i18n/LanguageContext';

// Freie-Übersetzung disclaimer — displayed at the bottom-left corner of
// every slide in every language except English (source language).
const TEXT = {
  de: 'Es handelt sich um eine freie Übersetzung.',
  fr: "Il s'agit d'une traduction libre.",
  es: 'Se trata de una traducción libre.',
  pt: 'Trata-se de uma tradução livre.',
  it: 'Si tratta di una traduzione libera.',
  nl: 'Het betreft een vrije vertaling.',
  sv: 'Det rör sig om en fri översättning.',
  pl: 'Jest to tłumaczenie swobodne.',
  cs: 'Jedná se o volný překlad.',
  sk: 'Ide o voľný preklad.',
  hu: 'Ez egy szabad fordítás.',
  ro: 'Este o traducere liberă.',
  sr: 'Radi se o slobodnom prevodu.',
  tr: 'Bu bir serbest çeviridir.',
  bg: 'Това е свободен превод.',
  el: 'Πρόκειται για ελεύθερη μετάφραση.',
  sl: 'Gre za prost prevod.',
  sq: 'Ky është një përkthim i lirë.',
  mk: 'Станува збор за слободен превод.',
  uk: 'Це вільний переклад.',
  ru: 'Это свободный перевод.',
  mt: 'Din hi traduzzjoni libera.',
  lb: 'Et handelt sech ëm eng fräi Iwwersetzung.',
  ar: 'هذه ترجمة حرة.',
  zh: '这是一个自由翻译。',
  ja: 'これは自由訳です。',
  ko: '이것은 자유 번역입니다.',
  hi: 'यह एक स्वतंत्र अनुवाद है।',
};

export default function FreeTranslationBadge() {
  const { lang } = useT();
  if (lang === 'en') return null;
  const t = TEXT[lang];
  if (!t) return null;
  return (
    <div
      className="free-translation-badge"
      data-testid="free-translation-badge"
      aria-hidden="true"
    >
      {t}
    </div>
  );
}
